module.exports = __webpack_public_path__ + "static/img/other-pc.edbdfa32.png";